import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, cld } from "@/lib/api";

const BIO =
  "Laszlo Abonyi is a contemporary painter whose work examines the intersection of architecture, memory, and atmosphere. Working primarily in oil, his paintings frequently explore mid-century modern architectural spaces, quiet twilight interiors, and expansive landscapes—capturing the surreal calm of places suspended between motion and stillness. Inspired by classic composition structures and a rich, deliberate use of colour and shadow, each piece invites the viewer into a space of quiet contemplation.";

const PORTRAIT = "https://res.cloudinary.com/hvdtsiq2/image/upload/v1792647567/20261008_122012.jpg";

const THEMES = [
  { t: "Architecture", d: "Mid-century modern rooms, glass walls and long horizontal lines — spaces built for light." },
  { t: "Interiors", d: "Quiet domestic corners at twilight: a favourite chair, a stack of books, a lamp just switched on." },
  { t: "Landscape", d: "Sun-soaked California poolsides, desert retreats and the moody edges of the Australian bush." },
];

export default function About() {
  const [works, setWorks] = useState([]);
  useEffect(() => {
    api.get("/products", { params: { category: "Original" } }).then((r) => setWorks(r.data)).catch(() => {});
  }, []);
  const detail = works.find((w) => w.slug === "a-good-place-to-stop") || works[1];

  return (
    <div data-testid="about-page">
      <section className="container-x grid gap-14 py-16 sm:py-24 md:grid-cols-12">
        <div className="md:col-span-6">
          <p className="eyebrow fade-up">About</p>
          <h1 className="fade-up mt-8 font-display text-5xl font-light leading-[1.05] sm:text-6xl" style={{ animationDelay: "120ms" }}>
            An exploration of light, architecture and stillness.
          </h1>
          <p className="fade-up mt-12 text-[17px] leading-[1.9] text-[#3A3733]" style={{ animationDelay: "240ms" }} data-testid="about-bio">{BIO}</p>
        </div>
        <div className="md:col-span-5 md:col-start-8">
          <img src={cld(PORTRAIT, "w_1200,q_auto,f_auto")} alt="Laszlo Abonyi" className="slow-fade aspect-[4/5] w-full object-cover" data-testid="about-portrait" />
        </div>
      </section>
      <section className="bg-[#F7F4EE]">
        <div className="container-x grid gap-14 py-24 md:grid-cols-3">
          {THEMES.map((x) => (
            <div key={x.t} className="border-t border-[#D9D3C7] pt-8">
              <h2 className="font-display text-3xl font-light">{x.t}</h2>
              <p className="mt-4 text-sm leading-relaxed text-[#5A626A]">{x.d}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="container-x grid items-center gap-14 py-24 sm:py-32 md:grid-cols-12">
        <div className="md:col-span-5">
          {detail && <img src={cld(detail.images[1] || detail.images[0], "w_1000,q_auto,f_auto")} alt="Brushwork detail" className="aspect-[4/5] w-full object-cover" />}
        </div>
        <div className="md:col-span-6 md:col-start-7">
          <p className="eyebrow">In the studio</p>
          <p className="mt-8 font-display text-3xl font-light leading-snug sm:text-4xl">
            Painted in rich oil and acrylic, with loose, impressionistic brushwork and a deliberate play of warm light against cool shadow.
          </p>
          <Link to="/gallery" className="btn-primary mt-12" data-testid="about-view-collection">View the collection</Link>
        </div>
      </section>
    </div>
  );
}
